import Vue from "vue";
import Router from "vue-router";
import Home from "@/components/Home";
import Popup from "@/components/Popup";

Vue.use(Router);

export default new Router({
	// mode: 'history',
	routes: [
		{
      path: "/",
      name: "Home",
			component: Home,
			children: [
        { path: "infiniti-usa-2019-QX50", component: Popup },
        { path: "nissan-usa-2018-leaf", component: Popup },
        { path: "mazda-canada-winter-sales-event", component: Popup },
        { path: "tender-birmingham", component: Popup },
        { path: "mazda-canada-summer-sales-event", component: Popup },
        { path: "ally-bank-surprise-and-delight", component: Popup },
        { path: "blue-cross-healthy-blue-xtras", component: Popup },
        { path: "infiniti-usa-exclusiviti", component: Popup },
        { path: "nissan-usa-2019-altima", component: Popup },
        { path: "mazda-canada-clubhouse-privileges", component: Popup }
			]
    }
	]
});



// WEBPACK FOOTER //
// ./src/router/index.js